import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Spin } from 'antd';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { FormCard, FormPageContainer, FormPageHeader } from '@/components/PageLayout';
import { useBrands } from '@/hooks/useBrandQueries';
import { useListReturn } from '@/hooks/useListReturn';
import { ROUTES } from '@/routes/routes';

import { EditBrandForm } from './EditBrandForm';

export const EditBrandPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { goToList } = useListReturn(ROUTES.BRANDS);
  const { data: brands, isLoading } = useBrands();

  if (isLoading) {
    return (
      <FormPageContainer>
        <Spin size="large" style={{ margin: 'auto' }} />
      </FormPageContainer>
    );
  }

  const brand = brands?.find((b) => b.id === Number(id));

  if (!brand) {
    return <Navigate to={ROUTES.BRANDS} />;
  }

  return (
    <FormPageContainer>
      <FormPageHeader>
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={goToList} />
        <h2>Редагувати бренд</h2>
      </FormPageHeader>
      <FormCard>
        <EditBrandForm brand={brand} />
      </FormCard>
    </FormPageContainer>
  );
};
